import { ValidationService } from './../service/validation.service';
import {
  Component,
  OnInit,
  Renderer2,
  Inject,
  forwardRef,
  ViewChildren,
  QueryList,
  ElementRef,
  ViewChild,
  HostListener,
  Input,
} from '@angular/core';
import { LocalStorageService } from '../local-storage.service';
import { CognitoService } from '../service/cognito.service';
import { TranslateService } from '@ngx-translate/core';
import { ClientService } from '../service/client.service';
import { ThemeService } from '../service/theme.service';
import { FilterService } from '../service/filter.service';
import {
  Collection,
  CollectionCount,
  DeviceConfig,
  IotService,
} from '../service/iot.service';
import { BinsService } from '../service/bins.service';
import {  Router } from '@angular/router';
import { DispatchService } from '../service/dispatch.service';
import { Bin, ReportsService } from '../service/reports.service';
import { DashboardService } from '../service/dashboard.service';
import { BinUsage } from '../constants/bin-usage';
import { DistributorsService } from '../service/distributors.service';
import { RouteService } from '../service/route.service';
import {ClientInterface} from '../service/dispatch.service';
import { ChatService } from '../service/chat.service';
import { firstValueFrom } from 'rxjs';
import { RouteStopStatus } from '../constants/route-stop-status';
import { LocalizationService } from '../service/localization.service';

interface Client {
  active: string; // e.g., "1" or "0"
  address: string; // e.g., "25 rue chap"
  auto_collect: string; // e.g., "1"
  checked: boolean; // e.g., false
  client_id: string; // e.g., "CL4ccb363d4cd095d853"
  client_logo: string | null; // e.g., null or a string
  client_name: string; // e.g., "jocelyn client"
  created: Date | null; // e.g., a date or null
  email: string; // e.g., "joccorm@gmail.com"
  legal_name: string; // e.g., "jocelyn"
  modified: Date | null; // e.g., a date or null
  mws: string; // e.g., "0"
  phone_number: string; // e.g., "4388375731"
}

@Component({
    selector: 'app-dispatch-network',
    templateUrl: './dispatch-network.component.html',
    styleUrls: [
        '../distributor-iot-dashboard/distributor-iot-dashboard.component.css',
        '../distributor-admin-dashboard/distributor-admin-dashboard.component.css',
        '../distributor-bins-model-dashboard/distributor-tiles.css',
        '../../global-elements.css',
        './dispatch-network.component.css',
    ],
    standalone: false
})
export class DispatchNetworkComponent implements OnInit {
  @Input() showPageLoader: boolean = true;
  @ViewChild('scroll') scrollElement: ElementRef | undefined;
  @ViewChild('routeMap') routeMapEl?: ElementRef<HTMLDivElement>;
  public isNavOpen = false;//to save status of nav menu
  public allThings: any[] = []; //to filter and display things list
  public originalAllThings: any[] = []; // to store the orginal things array
  //public selecteClientThings: Devices[] = [];// to save a selected client things potential use
  public clientArray: any[] = [];// to filter and display the client list
  public originalClientArray: any[] = [];//to save the original client array
  public allClients: any[] = [];// full client list for device filtering
  public activeTab: string = ''; // to save the active tab in the UI
  public isClientsTabOpen = false;// to save status of Client tab
  public isDevicesTabOpen = false;// to save status of device tab
  public isRoutesTabOpen = false;// to save status of associated client tab
  public isZonesTabOpen = false;// to save status of zones tab
  public tabsReady = false;
  public clientSearch = '';// to search for a specific client based on active filter
  public deviceSearch = '';// to search for a specific device based on active filter
  public filterBy = '';// the property to filter the client's array by
  public filterDeviceBy = '';// the property to filter the device's array by
  public selectedClientId: string = '';// client filter for device list
  public sortDeviceBy: string = '';// the property to sort devices by
  private readonly dispatchTabKey = 'dispatchNetworkActiveTab';
  public clientFilterOptions = [
    { label: 'clientcreateFormInputClientName', value: 'client_name' },
    { label: 'clientcreateFormInputLegalName', value: 'legal_name' },
    { label: 'email', value: 'email' },
  ];
  public clientSortOptions = [
    { label: 'clientcreateFormInputClientName', value: 'client_name' },
    { label: 'clientcreateFormInputLegalName', value: 'legal_name' },
    { label: 'email', value: 'email' },
  ];
  public deviceSortOptions = [
    { label: 'LastActivity', value: 'lastUpdate' },
    { label: 'iotModalHeaderBattery', value: 'battery' },
    { label: 'fillRate', value: 'fill' },
  ];
  @ViewChildren('clientCheckbox') checkboxes!: QueryList<ElementRef>;// list of client input checkboxes
  public sortBy: string = '';// the property to sort clients by
  public thingStatusArray: any;// an array of things status
  // Array Fetch customer data
  public ascDesc: number = 0; // the sort order
  public isSortBy: boolean = false; // the active status of client sort by element
  public isSortDeviceBy: boolean = false;// the active status of device sort by element
  public startDate: any = this.reports.getFirstDateOfTheCurrentYear();// get first day of current year for report data
  public endDate: any = this.reports.getCurrentDate(); // get current date for report data
  public collectionData: Collection[] = [];// to save collection data
  public collectionCountData: CollectionCount[] = []; // to save count collection data
  public things: any; // an array of thing name
  public deviceNameList: string[] = []; // list of all devices name for report data
   // For info bubble
   public showStateInfo: boolean[] = [];
  public showingAssociations: boolean = false;
  public operatorId = '';
  public routes: any[] = [];
  public loadingRoutes = true;
  public pageLoading = true;
  public openRouteMenuId: string | null = null;
  public showStopsModal = false;
  public showExportModal = false;
  public selectedRoute: any = null;
  public routeStops: any[] = [];
  public routeStopsGrouped: any[] = [];
  public exportStops: any[] = [];
  public exportStopsGrouped: any[] = [];
  public exportStartAddress = '';
  public exportLinks: string[] = [];
  public exportLoading = false;
  public exportErrorKey = '';
  public openStopKey: string | null = null;
  private stopStatusLabelMap = new Map(RouteStopStatus.map((status) => [status.value, status.label]));
  // Cache computed values to avoid recomputing for every change detection cycle.
  private routeApproxLitersById = new Map<string, number>();
  private routeStopCountById = new Map<string, number>();
  // Cache reverse-geocoded addresses by stop key for the View Stops modal.
  private stopAddressByKey = new Map<string, string>();
  private exportAutocomplete: google.maps.places.Autocomplete | null = null;
  @ViewChild('exportStartInput') exportStartInput?: ElementRef<HTMLInputElement>;
  private routeMapInstance: google.maps.Map | null = null;
  private routeMarkers: google.maps.Marker[] = [];
  tonnage: any;//to save calculated tonnage.
  public binData: Bin = { // bin data object
    above_ground: 0,
    active: 0,
    bin_address: '',
    bin_depth: 0,
    bin_height: 0,
    bin_id: '',
    bin_gps: '',
    bin_location: '',
    bin_model_number: '',
    bin_postal_code: '',
    bin_shape: '',
    bin_usage: '',
    bin_width: 0,
    client_id: '',
    distributor_id: '',
    thing_name: '',
    bin_volume: 0,
  };

  constructor(
    @Inject(forwardRef(() => TranslateService))
    private translate: TranslateService,
    private localStorageService: LocalStorageService,
    private renderer: Renderer2,
    private cognitoService: CognitoService,
    private clientService: ClientService,
    public dispatchService: DispatchService,
    public distributors: DistributorsService,
    public iotService: IotService,
    public reports: ReportsService,
    public validationService: ValidationService,
    private router: Router,
    public theme: ThemeService,
    public dashboardService: DashboardService,
    private filter: FilterService,
    public binService: BinsService,
    public routeService:RouteService,
    public chatService:ChatService,
    public dashboard: DashboardService,
    private localizationService: LocalizationService

  ) {}
  async ngOnInit() {
    console.log('staarting')
    await this.cognitoService.getUser();
    this.operatorId = this.cognitoService.userInfos.attributes['custom:operations_id'] || '';
    this.restoreActiveTab();
    this.tabsReady = true;
    this.loadingRoutes = true;
    try {
      await this.getClientList(); // get the client list
      await this.initializeDeviceData(); // Set up the each device data
      await this.loadRoutes();
    } finally {
      this.pageLoading = false;
    }
  }
  ngAfterViewInit() {
    // Accessing the scroll element after view initialization
    const scrollEl = this.scrollElement?.nativeElement;
    const tolerance = 2; //tolerance in pixels for bottom of the page
    // Adding scroll event listener
    scrollEl.addEventListener('scroll', () => {
      //console.log("Scroll position inside device-list:", scrollEl.scrollTop);
      // You can perform further actions with the scroll position here
      const bottomMostPosition =  scrollEl.scrollHeight - scrollEl.clientHeight
      const topMostPosition = scrollEl.clientHeight - scrollEl.scrollHeight
      if (Math.abs(scrollEl.scrollTop - bottomMostPosition) <= tolerance) {
        console.log("You are at the bottom or close to it!");
        window.scrollTo(0, document.documentElement.scrollHeight);
    }
    if(Math.abs(scrollEl.scrollTop) < tolerance){
      window.scrollTo(0, 0);
    }
    });
  }

  /**
   * Function that get all the clients
   */
  async getClientList() {
    try {
      const operatorSUB = await this.cognitoService.userInfos.attributes.sub // don't make it a call use already populated objects
      const res: any = await firstValueFrom(this.dispatchService.getAssociatedClients(operatorSUB))
        console.log(res)
        this.clientArray = res; // Fill the array with customer data
        this.originalClientArray = res; // Save the orginal client array
        this.allClients = res;
        this.clientArray.forEach((client) => {
          //create a checked property for UI selection
          client.checked = false;
        });
    } catch (error) {
      console.error('Error: ', error);
    }
  }

  /**
   * Function that initialize each thing's data
   */
  async initializeDeviceData() {
    const res: { thing_name: string }[] = await firstValueFrom(this.dispatchService.getAllThings())
    const things = res.map((item) => item.thing_name); //get the list of thing names
    this.deviceNameList = things;
    this.getReport(this.deviceNameList); // Get report data for each things in the list
  }

  /**
   * Function that get report data for a list of things
   * @param {string[]} thingList - The list of device to get the report
   */
  async getReport(thingList: string[]) {
    //convert date to unix
    const start = this.dateToUnixTimestamp(this.startDate);
    const end = this.dateToUnixTimestamp(this.endDate + 'T23:59:59');
    //get things status array
    const data = await this.iotService.getDeviceHealth(thingList);
    this.iotService.thingStatusArray = JSON.parse(data.status);
    //get the report data
    const result: any = await this.reports.getReportData(thingList, start, end, false)

    this.collectionData = JSON.parse(result.collections);
    this.collectionCountData = JSON.parse(result.counts);


    for (const filteredItem of this.iotService.thingStatusArray) {
      // Retrieve configurations, bin data, and shadows for the current filtered item
      const config: DeviceConfig[] = JSON.parse(data.configs).filter(
        (item: DeviceConfig) => item.thing_name === filteredItem.thing_name
      );
      const bins: any[] = JSON.parse(data.bins).filter(
        (item: any) => item.thing_name === filteredItem.thing_name
      );
      const [bin] = bins || [];
      const shadows = JSON.parse(data.shadows).filter(
        (item: any) => item.thing_name === filteredItem.thing_name
      );
      const [shadow] = shadows || [];
      const device = this.dashboardService.getDevicesStructure(
        shadow,
        bin,
        config
      );
      // Retrieve report data asynchronously
      const collectionData = this.iotService.filterCollectionsByThingName(
        this.collectionData,
        filteredItem.thing_name
      );
      const counts = this.iotService.filterCollectionsCountsByThingName(
        this.collectionCountData,
        filteredItem.thing_name
      );

      // Update bin data
      this.binData.bin_volume = bin.total_volume || 0;
      this.binData.bin_height = bin.bin_height || 0;
      this.binData.bin_usage = bin.bin_usage ?? '';

      let cubicMetersOfWasteTotal = 0;

      // Iterate through collection data
      for (let index = 0; index < collectionData.length; index++) {
        // Calculate cubic meters of waste total
        cubicMetersOfWasteTotal += this.calculateCubicMeters(
          this.binData.bin_volume,
          counts?.avg_preceding_dst ?? 0,
          this.binData.bin_height
        );
      }

      // Calculate tonnage
      const tonnage =
        this.calculateWasteCollection(
          this.binData.bin_usage,
          cubicMetersOfWasteTotal // Usar a cubagem total para calcular a tonelagem
        ) * 0.001;

      // Update tonnage
      this.tonnage = parseFloat(tonnage.toFixed(1)); // Atribuir a tonelagem total

      let distance_to_lid = filteredItem.distance_to_lid;
      let lastUpdate = 0;

      if (filteredItem.last_update) {
        lastUpdate = new Date(Number(filteredItem.last_update)).getTime();
      }

      // Check if necessary data is available for further processing
      if (bin && distance_to_lid && device.config?.slp) {
        let object = {
          tonnage: this.tonnage,
          battery: filteredItem.battery,
          distance_to_lid: filteredItem.distance_to_lid,
          last_update: filteredItem.last_update,
          status: filteredItem.status,
          thing_name: filteredItem.thing_name,
          bin_capacity: bin.bin_height,
          location: bin.bin_address ?? '',
          fill_level: this.iotService.checkFillLevelPercentage(
            distance_to_lid,
            bin.bin_height
          ),
          bin_id: bin.bin_id ?? '',
          heartbeat: this.iotService.verifyDeviceHeartBeat(
            this.iotService.filterDeviceConfig(
              config,
              shadow.thing_name,
              'last'
            ),
            this.iotService.filterDeviceConfig(
              config,
              shadow.thing_name,
              'second_last'
            ),
            shadow.dst_timestamp,
            shadow.tm2
          ),
          sleep_time: device.config?.slp ?? 0,
          device: device,
        };

        // Push filtered object to array
        this.allThings.push(object);

        // Reset tonnage and bin data
        this.tonnage = 0;
        this.binData.bin_volume = 0;
        this.binData.bin_height = 0;
        this.binData.bin_usage = '';
      }
      this.originalAllThings = this.allThings;
    }
    /* let cubicMetersOfWasteTotal; */
  }

  /**
   * Function that toggles the nav
   */
  toggleMenu() {
    this.isNavOpen = !this.isNavOpen;
    console.log(this.isNavOpen);
  }
  /**
   * Function that handles navigation
   * @param {number} tab - the tab tab to  navigate to
   */
  async navigate(tab: number) {
    switch (tab) {
      case 1: //to clients
        this.setActiveTab('client');
        break;
      case 2: //to devices
        this.setActiveTab('device');
        break;
      case 3: //to routes
        this.setActiveTab('routes');
        break;
      case 4: //to zones
        this.setActiveTab('zones');
        break;
    }
  }

  private restoreActiveTab() {
    const stored = this.localStorageService.getItem(this.dispatchTabKey);
    const tabRaw = typeof stored === 'string' ? stored : 'client';
    const tab = tabRaw === 'associations' ? 'routes' : tabRaw;
    this.setActiveTab(tab);
  }

  private setActiveTab(tab: string) {
    this.isClientsTabOpen = tab === 'client';
    this.isDevicesTabOpen = tab === 'device';
    this.isRoutesTabOpen = tab === 'routes';
    this.isZonesTabOpen = tab === 'zones';
    this.activeTab = tab;
    this.localStorageService.addItem(this.dispatchTabKey, tab);
  }

  async loadRoutes() {
    if (!this.operatorId) {
      return;
    }
    this.loadingRoutes = true;
    try {
      this.routes = await this.routeService.getDispatchRoutesByOperatorId(this.operatorId, false);
      // Populate derived values that depend on route stops and device telemetry.
      await this.populateRouteApproxLiters(this.routes);
    } catch (error) {
      console.error('Failed to load routes', error);
      this.routes = [];
    } finally {
      this.loadingRoutes = false;
    }
  }

  toggleRouteMenu(routeId: string) {
    this.openRouteMenuId = this.openRouteMenuId === routeId ? null : routeId;
  }

  closeRouteMenu() {
    this.openRouteMenuId = null;
  }

  @HostListener('document:click')
  handleDocumentClick() {
    if (this.openRouteMenuId !== null) {
      this.closeRouteMenu();
    }
  }

  getRouteStopCount(route: any): number {
    const routeId = route?.route_id;
    if (routeId && this.routeStopCountById.has(routeId)) {
      return this.routeStopCountById.get(routeId) ?? 0;
    }
    // Fallback to backend-provided stop_count when we do not have grouped stops yet.
    return Number(route?.stop_count || 0);
  }

  getRouteStatus(route: any): string {
    const optimized = !!route.optimization_status || !!route.last_optimized_at;
    return optimized ? 'Optimized' : 'Unoptimized';
  }

  getApproxLiters(route: any): number {
    const routeId = route?.route_id;
    if (routeId && this.routeApproxLitersById.has(routeId)) {
      return this.routeApproxLitersById.get(routeId) ?? 0;
    }
    // Display 0 until telemetry-based calculation is available.
    return 0;
  }

  private async populateRouteApproxLiters(routes: any[]) {
    this.routeApproxLitersById.clear();
    this.routeStopCountById.clear();
    if (!Array.isArray(routes) || !routes.length) {
      return;
    }

    // Load stops for each route so we can:
    // 1) compute grouped stop counts for the route tile
    // 2) collect thing_names for telemetry-based liters
    const routeStopsById = new Map<string, any[]>();
    await Promise.all(
      routes.map(async (route) => {
        const routeId = route?.route_id;
        if (!routeId) {
          return;
        }
        try {
          const stops = await this.routeService.getDispatchRouteStops(routeId);
          const list = Array.isArray(stops) ? stops : [];
          routeStopsById.set(routeId, list);
          const grouped = this.groupRouteStops(list);
          this.routeStopCountById.set(routeId, grouped.length);
        } catch (error) {
          console.error('Failed to load route stops for approx liters', error);
          routeStopsById.set(routeId, []);
          this.routeStopCountById.set(routeId, 0);
        }
      })
    );

    const allThingNames = new Set<string>();
    for (const stops of routeStopsById.values()) {
      for (const stop of stops) {
        this.getStopThingNames(stop).forEach((name) => allThingNames.add(name));
      }
    }

    if (!allThingNames.size) {
      routes.forEach((route) => {
        if (route?.route_id) {
          this.routeApproxLitersById.set(route.route_id, 0);
        }
      });
      return;
    }

    // Efficient batch call: only fetch telemetry for the devices used in these routes.
    const deviceHealth = await this.iotService.getDeviceHealth(Array.from(allThingNames));
    const bins = JSON.parse(deviceHealth.bins || '[]');
    const shadows = JSON.parse(deviceHealth.shadows || '[]');

    const binByThing = new Map<string, any>();
    bins.forEach((bin: any) => {
      if (bin?.thing_name) {
        binByThing.set(bin.thing_name, bin);
      }
    });

    const shadowByThing = new Map<string, any>();
    shadows.forEach((shadow: any) => {
      if (shadow?.thing_name) {
        shadowByThing.set(shadow.thing_name, shadow);
      }
    });

    routes.forEach((route) => {
      const routeId = route?.route_id;
      if (!routeId) {
        return;
      }
      const stops = routeStopsById.get(routeId) || [];
      const routeThings = new Set<string>();
      stops.forEach((stop) => {
        this.getStopThingNames(stop).forEach((name) => routeThings.add(name));
      });

      // Sum liters per unique device to avoid double-counting.
      let total = 0;
      routeThings.forEach((thingName) => {
        total += this.getThingApproxLiters(thingName, binByThing, shadowByThing);
      });
      this.routeApproxLitersById.set(routeId, Math.round(total));
    });
  }

  private getThingApproxLiters(
    thingName: string,
    binByThing: Map<string, any>,
    shadowByThing: Map<string, any>
  ): number {
    const bin = binByThing.get(thingName);
    const shadow = shadowByThing.get(thingName);
    const binHeight = Number(bin?.bin_height);
    const totalVolume = Number(bin?.total_volume);
    const dst = Number(shadow?.dst);

    // Guard against invalid telemetry / bin metadata.
    if (!Number.isFinite(binHeight) || binHeight <= 0) {
      return 0;
    }
    if (!Number.isFinite(totalVolume) || totalVolume <= 0) {
      return 0;
    }
    if (!Number.isFinite(dst) || dst < 0 || dst > binHeight) {
      return 0;
    }

    // Fill % is based on distance-to-lid (dst) vs bin height (mm).
    const fillPct = ((binHeight - dst) / binHeight) * 100;
    const clampedPct = Math.min(100, Math.max(0, fillPct));
    return (totalVolume * clampedPct) / 100;
  }

  async openStops(route: any) {
    this.selectedRoute = route;
    this.showStopsModal = true;
    try {
      this.routeStops = await this.routeService.getDispatchRouteStops(route.route_id);
      this.routeStopsGrouped = this.groupRouteStops(this.routeStops);
      this.populateStopAddresses(this.routeStopsGrouped);
      this.openStopKey = null;
      setTimeout(() => this.renderRouteMap(), 0);
    } catch (error) {
      console.error('Failed to load route stops', error);
      this.routeStops = [];
    }
  }

  closeStopsModal() {
    this.showStopsModal = false;
    this.selectedRoute = null;
    this.routeStops = [];
    this.routeStopsGrouped = [];
    this.clearRouteMarkers();
    this.openStopKey = null;
    this.stopAddressByKey.clear();
  }

  toggleStopDetails(stop: any) {
    const key = this.getStopKey(stop);
    this.openStopKey = this.openStopKey === key ? null : key;
  }

  isStopOpen(stop: any): boolean {
    return this.openStopKey === this.getStopKey(stop);
  }

  isStopCancelled(stop: any): boolean {
    const stops = stop?.groupStops?.length ? stop.groupStops : [stop];
    // If any device in the grouped stop is cancelled, treat the stop as cancelled.
    return stops.some((item: any) => String(item?.status || '').toUpperCase() === 'X');
  }

  private getStopKey(stop: any): string {
    // Prefer API-provided grouping key, otherwise fall back to per-stop id.
    return stop?.stop_group_key || stop?.route_stop_id || '';
  }

  getStopDisplayAddress(stop: any): string {
    const key = this.getStopKey(stop);
    const cached = key ? this.stopAddressByKey.get(key) : null;
    if (cached) {
      return cached;
    }
    // Fallback to bin_address if GPS is unavailable or reverse geocoding hasn't completed.
    return stop?.bin_address || stop?.bin_id || '—';
  }

  getStopDetailStops(stop: any): any[] {
    return stop?.groupStops?.length ? stop.groupStops : [stop];
  }

  getStopBinCount(stop: any): number {
    if (stop?.groupStops?.length) {
      return stop.groupStops.length;
    }
    return 1;
  }

  getStopClientLabel(stop: any): string {
    return stop?.client_name || stop?.client_names || '—';
  }

  getStopStatusLabel(status: string): string {
    return this.stopStatusLabelMap.get(status) || status || '—';
  }

  private async populateStopAddresses(stops: any[]) {
    const requests: Promise<void>[] = [];
    (stops || []).forEach((stop) => {
      const gps = this.normalizeCoordString(stop?.bin_gps);
      const key = this.getStopKey(stop);
      if (!gps || !key || this.stopAddressByKey.has(key)) {
        return;
      }
      const [latRaw, lngRaw] = gps.split(',');
      const lat = Number(latRaw);
      const lng = Number(lngRaw);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return;
      }
      // Reverse geocode GPS to a human-readable street address for display.
      requests.push(
        this.localizationService
          .getAddressFromGps(lat, lng)
          .then((address) => {
            if (address) {
              this.stopAddressByKey.set(key, address);
            }
          })
          .catch(() => {
            // Fallback to bin_address in template
          })
      );
    });

    if (requests.length) {
      await Promise.all(requests);
    }
  }

  async openExportModal(route: any) {
    this.selectedRoute = route;
    this.showExportModal = true;
    this.exportStartAddress = '';
    this.exportLinks = [];
    this.exportErrorKey = '';
    this.exportStops = [];
    await this.loadExportStops(route);
    setTimeout(() => this.initExportAutocomplete(), 0);
  }

  closeExportModal() {
    this.showExportModal = false;
    this.exportStartAddress = '';
    this.exportLinks = [];
    this.exportErrorKey = '';
    this.exportStops = [];
    this.exportStopsGrouped = [];
    this.exportAutocomplete = null;
  }

  private initExportAutocomplete() {
    if (!this.exportStartInput?.nativeElement || !(window as any).google?.maps?.places) {
      return;
    }
    const options: google.maps.places.AutocompleteOptions = {
      types: ['geocode'],
      fields: ['place_id', 'geometry', 'name', 'formatted_address'],
    };
    this.exportAutocomplete = new google.maps.places.Autocomplete(
      this.exportStartInput.nativeElement,
      options
    );
    this.exportAutocomplete.addListener('place_changed', () => {
      const selectedPlace = this.exportAutocomplete?.getPlace();
      if (selectedPlace) {
        const formatted =
          selectedPlace.formatted_address ||
          selectedPlace.name ||
          selectedPlace.address_components?.map((component) => component.long_name).join(', ') ||
          '';
        if (formatted) {
          this.exportStartAddress = formatted;
        }
      }
    });
  }

  private async loadExportStops(route: any) {
    this.exportLoading = true;
    try {
      this.exportStops = await this.routeService.getDispatchRouteStops(route.route_id);
      this.exportStopsGrouped = this.groupRouteStops(this.exportStops);
    } catch (error) {
      console.error('Failed to load route stops for export', error);
      this.exportStops = [];
      this.exportStopsGrouped = [];
      this.exportErrorKey = 'routeExportLoadError';
    } finally {
      this.exportLoading = false;
    }
  }

  generateExportLinks() {
    const originRaw = this.exportStartAddress.trim();
    if (!originRaw) {
      this.exportErrorKey = 'routeExportStartRequired';
      this.exportLinks = [];
      return;
    }
    const stopLocations = this.exportStopsGrouped
      .map((stop) => this.getStopLocation(stop))
      .filter((value) => !!value);
    if (!stopLocations.length) {
      this.exportErrorKey = 'routeExportNoStops';
      this.exportLinks = [];
      return;
    }
    const links: string[] = [];
    const chunkSize = 8;
    let origin = originRaw;
    for (let i = 0; i < stopLocations.length; i += chunkSize) {
      const chunk = stopLocations.slice(i, i + chunkSize);
      if (!chunk.length) {
        break;
      }
      const destination = chunk[chunk.length - 1];
      const waypoints = chunk.slice(0, -1);
      links.push(this.buildGoogleMapsLink(origin, destination, waypoints));
      origin = destination;
    }
    this.exportLinks = links;
    this.exportErrorKey = '';
  }

  private getStopLocation(stop: any): string {
    const target = stop?.groupStops?.[0] || stop;
    const raw = (target?.bin_gps || target?.bin_location || target?.bin_address || '').trim();
    return raw;
  }

  private normalizeCoordString(coord: any): string | null {
    if (coord === null || coord === undefined) {
      return null;
    }
    const raw = String(coord).trim();
    if (!raw || !raw.includes(',')) {
      return null;
    }
    const [latRaw, lngRaw] = raw.split(',').map((v) => v.trim());
    const lat = Number(latRaw);
    const lng = Number(lngRaw);
    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return null;
    }
    return `${lat.toFixed(6)},${lng.toFixed(6)}`;
  }

  private getStopGroupKey(stop: any): string {
    // Group by GPS first (most precise), then fall back to address or location.
    const gps = this.normalizeCoordString(stop?.bin_gps);
    if (gps) {
      return `gps:${gps}`;
    }
    const addr = (stop?.bin_address || '').trim();
    if (addr) {
      return `addr:${addr.toLowerCase()}`;
    }
    const loc = (stop?.bin_location || '').trim();
    if (loc) {
      return `loc:${loc.toLowerCase()}`;
    }
    return 'unknown';
  }

  private groupRouteStops(stops: any[]): any[] {
    const groups = new Map<string, any>();
    for (const stop of stops || []) {
      const key = stop?.stop_group_key || this.getStopGroupKey(stop);
      let group = groups.get(key);
      if (!group) {
        const parts = key.split(':', 2);
        group = {
          ...stop,
          stop_group_key: key,
          stop_group_type: stop?.stop_group_type || parts[0] || null,
          stop_group_value: stop?.stop_group_value || parts[1] || null,
          groupStops: [],
          stop_group_size: 0,
        };
        groups.set(key, group);
      }
      group.groupStops.push(stop);
      group.stop_group_size = group.groupStops.length;
    }
    return Array.from(groups.values());
  }

  private buildGoogleMapsLink(origin: string, destination: string, waypoints: string[]): string {
    const base = 'https://www.google.com/maps/dir/?api=1';
    const params = [
      `origin=${encodeURIComponent(origin)}`,
      `destination=${encodeURIComponent(destination)}`,
    ];
    if (waypoints.length) {
      params.push(`waypoints=${encodeURIComponent(waypoints.join('|'))}`);
    }
    return `${base}&${params.join('&')}`;
  }

  getStopThingNames(stop: any): string[] {
    const stops = stop?.groupStops?.length ? stop.groupStops : [stop];
    const unique = new Set<string>();
    stops.forEach((item: any) => {
      const rawList = (item?.thing_names || '').trim();
      if (rawList) {
        rawList
          .split(',')
          .map((value: string) => value.trim())
          .filter((value: string) => value.length > 0)
          .forEach((value: string) => unique.add(value));
      }
      const name = (item?.thing_name || '').trim();
      if (name) {
        unique.add(name);
      }
    });
    return Array.from(unique.values());
  }

  async updateStopStatus(stop: any, status: string) {
    try {
      const stops = stop?.groupStops?.length ? stop.groupStops : [stop];
      let allOk = true;
      for (const s of stops) {
        const success = await this.routeService.updateRouteStopHTTP(s.route_stop_id, status);
        if (success) {
          s.status = status;
        } else {
          allOk = false;
        }
      }
      if (allOk) {
        stop.status = status;
      }
    } catch (error) {
      console.error('Failed to update stop status', error);
    }
  }

  private renderRouteMap() {
    if (!this.routeMapEl?.nativeElement || !(window as any).google?.maps) {
      return;
    }
    const map = new google.maps.Map(this.routeMapEl.nativeElement, {
      center: { lat: 45.5017, lng: -73.5673 },
      zoom: 9,
      disableDefaultUI: true,
    });
    this.routeMapInstance = map;
    this.clearRouteMarkers();

    const bounds = new google.maps.LatLngBounds();
    const stops = this.routeStopsGrouped.length ? this.routeStopsGrouped : this.routeStops;
    stops.forEach((stop) => {
      const target = stop?.groupStops?.[0] || stop;
      if (!target.bin_gps || !target.bin_gps.includes(',')) {
        return;
      }
      const [latRaw, lngRaw] = target.bin_gps.split(',').map((v: string) => v.trim());
      const lat = Number(latRaw);
      const lng = Number(lngRaw);
      if (Number.isNaN(lat) || Number.isNaN(lng)) {
        return;
      }
      const marker = new google.maps.Marker({
        position: { lat, lng },
        title: (target.bin_address || target.bin_id) + (stop.stop_group_size > 1 ? ` (x${stop.stop_group_size})` : ''),
      });
      marker.setMap(map);
      this.routeMarkers.push(marker);
      bounds.extend(marker.getPosition()!);
    });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
      if (map.getZoom() && map.getZoom()! > 12) {
        map.setZoom(12);
      }
    }

    // Ensure map tiles render correctly when opened inside a modal.
    setTimeout(() => {
      google.maps.event.trigger(map, 'resize');
      if (!bounds.isEmpty()) {
        map.fitBounds(bounds);
        if (map.getZoom() && map.getZoom()! > 12) {
          map.setZoom(12);
        }
      }
    }, 0);
  }

  private clearRouteMarkers() {
    this.routeMarkers.forEach((marker) => marker.setMap(null));
    this.routeMarkers = [];
  }
  /**
   * Function that format a 10 digits phone number
   * @param numberSequence - the  number sequence to format
   * @returns formatted phone number to (XXX) XXX-XXXX or original sequence
   */
  formatNumber(numberSequence: string | undefined | null): string {
    // If the input is undefined or null, return an empty string (or handle the case appropriately)
    if (numberSequence === undefined || numberSequence === null) {
      return ''; // or handle the case appropriately
    }

    // If the length of the cleaned number is 10, format it as (XXX) XXX-XXXX
    const justNumbers = numberSequence.replace(/\D/g, '');

    if (justNumbers.length === 10) {
      const parte1 = justNumbers.slice(0, 3);
      const parte2 = justNumbers.slice(3, 6);
      const parte3 = justNumbers.slice(6);
      return `(${parte1}) ${parte2}-${parte3}`;
    } else {
      // If the length is not 10, return the input as is
      return numberSequence;
    }
  }

  /**
   * Function used to made a search in the list
   * @param {number} i - Optional parameter that defaults search for thing name
   */
  search(i?: number) {
    // Check if there's a filterBy variable and set it to it's default value

    if (i && i === 1) {
      if (this.filterDeviceBy === '') {
        this.filterDeviceBy = 'thing_name';
      }

      this.allThings = this.filter.search(
        this.deviceSearch,
        this.allThings,
        this.originalAllThings,
        this.filterDeviceBy
      );
      return;
    }
    if (this.filterBy === '') {
      this.filterBy = 'legal_name';
    }
    //search inputed client
    this.clientArray = this.filter.search(
      this.clientSearch,
      this.clientArray,
      this.originalClientArray,
      this.filterBy
    );
  }

  /**
   * Function that closes the navigation menu when user is navigating
   *
   */
  adjustSideBar() {
    if (!this.isNavOpen) {
      //do nothing if nav is closed
      return;
    }
    this.isNavOpen = false; //close the nav
  }
  openModal(client:ClientInterface){
    //TODO in rework of  this component, API call changed, nends t be adater here
    //this.chatService.getOperatorChatUsers();

    console.log(client)
  }


  /**
   * Function that set each client's checked state to the state of the "Select All" checkbox
   * @param event - used to access the  caller element
   */
  toggleSelectAll(event: Event) {
    //get checked value of select all checkbox
    const checked = (event.target as HTMLInputElement).checked;
    switch (this.activeTab) {
      case 'client':
        this.clientArray.forEach((client) => {
          client.checked = checked; //
        });
        break;
      case 'associations':
        this.dispatchService.associatedClients.forEach((client) => {
          client.checked = checked;
        });
        break;
    }
  }

  toggleAssociatedClient(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if(checked){
      this.showingAssociations = true
      this.clientArray = this.clientArray.filter((thing) => {
        return this.dispatchService.associatedClients.find((client) => {
          return client.client_id === thing.client_id;
        });
      });
    } else{
      this.clientArray = this.originalClientArray
      this.showingAssociations = false
    }
  }

  /**
   * Function that set each client's checked state to the state of the "Select All" checkbox
   * @param event - used to access the  caller element
   */
  toggleAssociatedClientDevice(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if(checked){
      this.showAssociatedClientDevice();
    } else {
      this.allThings = this.originalAllThings;
    }
  }
  /**
   *
   * @returns boolean showing the checked status
   */
  areAllChecked(): boolean {
    return this.clientArray.every((client) => client.checked);
  }

  /**
   * Function that shows associated client devices in the device tab
   */
  showAssociatedClientDevice() {
    //filter allThings to show up only associated client devices
    this.allThings = this.allThings.filter((thing) => {
      return this.dispatchService.associatedClients.find((client) => {
        return client.client_id === thing?.device?.bin?.client_id;
      });
    });
  }

  /**
   * Function that count the devices associated with each client
   * @param clientID
   * @returns number of device
   */
  countDevice(clientID: string) {
    const deviceCount = this.allThings.filter((thing) => {
      return thing?.bin?.client_id === clientID;
    });
    console.log(deviceCount);
    return deviceCount.length;
  }

  /**
   * Function that select client passed
   * @param client client object
   */
  select(client: Client) {
    client.checked = !client.checked;
  }

  /**
   *Function that checks if there is at least 1 checked client
   * @returns true for at least 1 checked client
   */
  hasCheckedClient(): boolean {
    return this.clientArray.some((client) => client.checked);
  }
  hasAssociatedClient(){
      return this.dispatchService.associatedClients.some((item)=>item.checked)
    }

  /**
   * Function that associate selected client to the current dispatch user
   */
  associateClients() {
    const checkedClients = this.clientArray.filter(
      (client) => client.checked === true
    ); //get all selected clients
    this.dispatchService.associateClient(checkedClients); // associate them to dispatch
    this.clientArray.forEach((client) => (client.checked = false)); //deselect all clients
  }
  /**
   * Function that dissociate selected client to the current dispatch user
   */
  dissociateClients() {
    const checkedClients = this.dispatchService.associatedClients.filter(
      (client) => client.checked === true
    ); //get all selected clients
    this.dispatchService.dissociateClient(checkedClients); // associate them to dispatch
    this.clientArray = this.dispatchService.associatedClients;
    this.clientArray.forEach((client) => (client.checked = false)); //deselect all clients
  }
  /**
   * Function that returns the number of devices associated to a specific client
   * @param clientID - The ID of the client
   * @returns number of device(s) associated to the client.
   */
  getDevices(clientID: string) {
    const deviceNum = this.allThings.filter((thing) => {
      return thing.device?.bin?.client_id === clientID; // Check if device.bin.client_Id matches the clientID
    });
    return deviceNum.length; // Return the array of matching devices
  }


  /**
   * Function that performs a new search every time the type of thing to be filtered changes
   */
  onFilterByChange() {
    this.resetUserArray(); // Reset user array
    this.search(); // Perform search based on selected filter
    this.clientSearch = ''; // Clear the user input filter
  }
  /**
   * Function called to reset the user array
   */
  resetUserArray() {
    this.clientArray = this.originalClientArray;
  }
  /**
   * Function triggered when user change sort by  fitler of client tab
   * @param caller to change either the sort order or sort filter
   * @param event
   */
  onSortChange(caller: string, event: any) {
    // Reset sortBy variable to hide the toggle switch when user press the X in the select
    if (event === undefined) {
      this.isSortBy = false;
    } else {
      this.isSortBy = true;
    }

    // Switch the value of ascending or descending
    if (caller === 'switch') {
      if (this.ascDesc === 0) {
        this.ascDesc = 1;
      } else {
        this.ascDesc = 0;
      }
    }

    // Avoid sortBy to have no value
    if (this.sortBy === '') {
      this.sortBy = 'legal_name';
    }

    // Function that sort the list
    this.clientArray.sort((a, b) => {
      switch (this.sortBy) {
        case 'client_name':
          return this.ascDesc === 1
            ? (b.client_name || '').localeCompare(a.client_name || '')
            : (a.client_name || '').localeCompare(b.client_name || '');

        case 'legal_name':
          return this.ascDesc === 1
            ? (b.legal_name || '').localeCompare(a.legal_name || '')
            : (a.legal_name || '').localeCompare(b.legal_name || '');

        case 'email':
          return this.ascDesc === 1
            ? (b.email || '').localeCompare(a.email || '')
            : (a.email || '').localeCompare(b.email || '');
      }
    });
  }
  /**
   * Function triggered when user change sort on collumn of device tab
   * @param caller caller to change either the sort order or sort filter
   * @param event
   */
  onSortDeviceChange(caller: string, event: any) {
    // Reset sortBy variable to hide the toggle switch when user press the X in the select
    if (event === undefined) {
      this.isSortDeviceBy = false;
    } else {
      this.isSortDeviceBy = true;
    }
    // Switch the value of ascending or descending
    if (caller === 'switch') {
      if (this.ascDesc === 0) {
        this.ascDesc = 1;
      } else {
        this.ascDesc = 0;
      }
    }
    switch (this.sortDeviceBy) {
      case 'lastUpdate':
        this.sortByLastUpdate();
        break;
      case 'battery':
        this.sortByBattery();
        break;
      case 'fill':
        this.sortByFill();
        break;
    }

    // Avoid sortBy to have no value
    if (this.sortDeviceBy === '') {
      this.allThings = this.originalAllThings;
    }
  }

  /**
   * Function that sort the device array based on last update
   */
  sortByLastUpdate() {
    this.allThings.sort((a, b) => {
      const aVal = Number(a.last_update) || 0;
      const bVal = Number(b.last_update) || 0;
      return this.ascDesc === 1 ? aVal - bVal : bVal - aVal;
    });
  }
  /**
   * Function that sort the device array based on associated bin fill level
   */
  sortByFill() {
    this.allThings.sort((a, b) => {
      const sortOrder = this.ascDesc ? 1 : -1;

      // If the status is "Inactive", move it to the end, regardless of fill Level
      if (a.status === 'Inactive' && b.status !== 'Inactive') {
        return 1;
      } else if (a.status !== 'Inactive' && b.status === 'Inactive') {
        return -1;
      }
      // If fill level unavailable, move it to the end, regardless of fill Level
      if (a.fill_level === 'N/A' && b.fill_level !== 'N/A') {
        return 1;
      } else if (a.fill_level !== 'N/A' && b.fill_level === 'N/A') {
        return -1;
      }

      let aFillLevel = 0;
      let bFillLevel = 0;

      if (a.fill_level && b.fill_level) {
        // Parse the string values into numeric values for fillLevel
        aFillLevel = parseFloat(a.fill_level.replace('%', ''));
        bFillLevel = parseFloat(b.fill_level.replace('%', ''));
      }

      // Compare the "fillLevel" properties of items
      if (aFillLevel < bFillLevel) {
        return -1 * sortOrder;
      } else if (aFillLevel > bFillLevel) {
        return 1 * sortOrder;
      } else {
        // If fillLevel values are equal, maintain the existing order
        return 0;
      }
    });
  }
  /**
   * Function that sort the device array based on battery level
   */
  sortByBattery() {
    this.allThings.sort((a, b) => {
      const sortOrder = this.ascDesc ? 1 : -1;
      const aBattery = Number(a.battery) || 0;
      const bBattery = Number(b.battery) || 0;
      if (
        (aBattery <= 100 && bBattery <= 100 && aBattery < bBattery) ||
        (aBattery > 100 && bBattery <= 100)
      ) {
        return -1 * sortOrder;
      } else if (
        (aBattery <= 100 && bBattery <= 100 && aBattery > bBattery) ||
        (aBattery <= 100 && bBattery > 100)
      ) {
        return 1 * sortOrder;
      } else {
        // If battery values are equal, maintain the existing order
        return 0;
      }
    });
  }

  /**
   * Filter devices list by selected client id.
   */
  filterDevicesByClient() {
    if (!this.selectedClientId) {
      this.allThings = this.originalAllThings;
      return;
    }
    this.allThings = this.originalAllThings.filter((thing) => {
      return thing?.device?.bin?.client_id === this.selectedClientId;
    });
  }
  /**
   * Function that toggles the display of the complete address of the user .
   * @param i the id of the address container
   */
  displayAddress(i: number) {
    //get the address container
    let element = document.getElementById(i.toString());
    //logic to display the address
    if (element && element.classList.contains('address')) {
      //to show complete address
      this.renderer.removeClass(element, 'address');
      this.renderer.addClass(element, 'addressVisible');
    } else {
      //to show address with ellipsis
      this.renderer.addClass(element, 'address');
      this.renderer.removeClass(element, 'addressVisible');
    }
  }

  /**
   * Function called to get the style of the columns of the grid list
   */
  getColumnStyle(): any {
    const numberOfColumn = this.ajustNumberOfColumns(this.getScreenWidth());
    if (numberOfColumn) {
      if (this.clientArray.length >= numberOfColumn) {
        const gridColumns = `repeat(${numberOfColumn}, minmax(0, 350px))`;
        return {
          'grid-template-columns': gridColumns,
        };
      } else {
        return {
          display: `flex`,
          'justify-content': `center`,
          margin: '0 -10px',
        };
      }
    }
  }

  /**
   * function called to adjust the number of column of the grid depbending of inner window width
   * @param {number} width - the width of the column
   * @returns Return the floor of the inner page width divided by 450 px as the width of the tile size
   */
  ajustNumberOfColumns(width: number): number | undefined {
    return Math.floor((width / 350) * (90 / 100));
  }

  /**
   * Function to get the current screen width
   */
  getScreenWidth(): number {
    // Return the inner width of the window as the screen width
    return window.innerWidth;
  }

  // Device tab functions

  /**
   * Function rhat set navigation anchor to dispatch-network for navigting back
   * @param thingName the name of the thing user wants to see satistics of
   */
  setNavToDeviceStat(thingName: string) {
    sessionStorage.setItem('toDeviceStats', 'dispatch-network');
    this.router.navigate([`/device-statistics/${thingName}`]);
  }
  /**
   * Gets the battery level style and information based on the provided battery level.
   * @param {any} batteryLevel - The battery level as any type (should be a number).
   * @returns {object} - An object containing icon, color, and title properties.
   */
  getBatteryLevel(batteryLevel: any): object {
    const result = {
      icon: '',
      color: '',
      title: '',
    };

    // Check if batteryLevel is a number and not NaN
    if (typeof batteryLevel === 'number' && !isNaN(batteryLevel)) {
      // Logic to set icon, color, and title based on the value of batteryLevel
      if (batteryLevel > 3.5) {
        return { color: '#63E6BE' };
      } else if (batteryLevel <= 3.5 && batteryLevel > 2.5) {
        return { color: '#63E6BE' };
      } else if (batteryLevel <= 2.5 && batteryLevel > 1.5) {
        return { color: '#FFD43B' };
      } else if (batteryLevel <= 1.5 && batteryLevel > 0) {
        return { color: '#f70202' };
      } else if (batteryLevel === 0) {
        return { color: '#f70202' };
      }

      result.title = `${batteryLevel}V`;
    } else {
      // If batteryLevel is not a number
      return { color: 'gray' };
    }

    return result;
  }
  /**
   * Function that get the style color depend on fill level of the bin
   * @param {string} fillLevel - the fill level of the device's associated bin
   * @returns
   */
  getFillLevelStyle(fillLevel: string): object {
    // Remove the percentage symbol
    let fillLevelWithoutPercent = '';
    if (fillLevel) {
      fillLevelWithoutPercent = fillLevel.replace('%', '');
    }

    // Convert to a floating-point number (float)
    const fillLevelFixed: number = parseFloat(fillLevelWithoutPercent);

    // Check if fillLevel is undefined
    if (fillLevel === undefined) {
      return { color: 'gray' }; // Style for gray color (default)
    }

    // Use the number for conditional comparisons
    if (fillLevelFixed <= 60) {
      return { color: 'green' }; // Style for green color
    } else if (fillLevelFixed <= 79.09) {
      return { color: '#B8860B' }; // Style for yellow color
    } else if (fillLevelFixed >= 79.09 && fillLevelFixed <= 100) {
      return { color: 'red' }; // Style for red color
    } else {
      return { color: 'gray' }; // Style for inactive (default)
    }
  }

  /**
   * Function used to set a date to unix timestamp
   * @param dateString - The date to convert to unix timestamp
   * @returns timestamp converted in seconds
   */
  dateToUnixTimestamp(dateString: string): number {
    // Parse the date string into a Date object
    const date = new Date(dateString);

    // Get the UTC timestamp in milliseconds
    const timestampInMilliseconds = date.getTime();

    // Convert milliseconds to seconds and return
    return Math.floor(timestampInMilliseconds / 1000);
  }

  /**
   * Function that will calculate the volume if all field are well filled
   * @param {number} binVolume - Total volume of the bin
   * @param {number} dst - distance to the captor
   * @param {number} binHeight - the height of the bin
   * @returns - return the calculated cubic meters
   */
  calculateCubicMeters(binVolume: number, dst: number, binHeight: number) {
    // Calculate the multiplier based on the given formula
    const multiplier = 1 - dst / binHeight;
    // Calculate the result - then return the calculated cubic meters
    return (binVolume / 1000) * multiplier;
  }

  /**
   * Functions that calculate the total waste collected
   * @param {string} usage -  the usage of the bin
   * @param {number} totalCubicMetersOfWaste - the total volume of waste  in cubic meters
   * @returns the total waste collected or 0 if invalid parameters
   */
  calculateWasteCollection(
    usage: string,
    totalCubicMetersOfWaste: number
  ): number {
    // Get the weight per cubic meter based on the given usage
    const weightPerCubicMeter = this.getWeightByValue(usage);

    // Check if the inputs are valid and return the calculated total waste collection
    if (!isNaN(totalCubicMetersOfWaste) && weightPerCubicMeter !== undefined) {
      return totalCubicMetersOfWaste * weightPerCubicMeter;
    } else {
      return 0; // Return 0 if inputs are not valid
    }
  }
  /**
   * Function that gets the average weight for the bin usage type
   * @param {string} usage - the usage of the bin
   * @returns the average weight for the bin usage type
   */
  getWeightByValue(usage: string): number {
    const bin = BinUsage.find((bin) => bin.value === usage);
    return bin?.weight || 0;
  }

  scrollToTop(){
    let targetElement;
    switch(this.activeTab){
      case 'client':
        targetElement =  document.getElementById('clientTop');
        break
      case 'device':
        targetElement =  document.getElementById('deviceTop');
        break
      case 'associations':
        targetElement =  document.getElementById('associationsTop');
        break
    }
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

}
